@let hero = data();

<div
  class="hero-split"
  [class.hero-split--image-right]="hero.imagePosition === 'right'"
  [class.hero-split--image-left]="hero.imagePosition === 'left'"
  [style.--hero-min-height.vh]="hero.splitMinHeight"
>
  <div class="hero-split__picture-wrapper">
    <picture class="hero-split__picture" [paiPicture]="hero.image" size="50vw" sizeSm="100vw" priority></picture>
  </div>

  <div class="hero-split__content">
    <h1 tabindex="-1">{{ hero.title || '-' }}</h1>
    <p [innerText]="hero.intro || '-'"></p>
    <!--    todo -->
    <!--    <ng-template [paiInsertDynamicComponent]="cta" />-->
  </div>
</div>
